var util = require("../util"),
    win = "object" == typeof window ? window : {},
    _catch = "catch",
    oFetch = win.__oFetch_ || win.fetch;

oFetch = "function" == typeof oFetch ? oFetch : undefined, module.exports = function (e, o) {
  var t = -1;
  "object" == typeof e && (t = e.z, e = util.serialize(e));
  var n = o + e;
  if (oFetch) return oFetch(n, {
    method: "HEAD",
    mode: "no-cors"
  })[_catch](util.noop);

  if (win.document && win.document.createElement) {
    var c = "__request_hold_" + t,
        i = win[c] = new Image();
    i.onload = i.onerror = function () {
      win[c] = undefined;
    }, i.src = n, i = null;
  }
};